<template>
  <component :is="layout">
    <router-view></router-view>
  </component>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
import StoreLayout from '@/layouts/StoreLayout.vue';
import Favicons from '@/components/meta/Favicons.js';
import CommonStore from '@/store/CommonStore.js';
import Chat from '@/components/commons/Chat.js';
import Chronicle from '@/components/commons/Chronicle.js';
import { debounce } from 'lodash-es';

export default {
  name: 'Article',

  metaInfo: {
    title: 'Modern, Mid Century & Scandinavian Furniture',
    titleTemplate: '%s | Article',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Shop article.com for high quality furniture at incredible prices for your Dining, Living and Bedroom.',
      },
    ],
    link: [...Favicons],
  },

  components: {
    StoreLayout,
  },

  async serverPrefetch() {
    this.$store.registerModule('common', CommonStore.initialize(), { preserveState: false });
    await this.fetchData();
    this.updateCurrentRoute();
  },

  beforeMount() {
    this.$store.registerModule('common', CommonStore.initialize(), { preserveState: process.env.STOREFRONT });

    this.getUser();
  },

  async mounted() {
    await this.getSessionData();
    this.loadMessaging();

    if (process.env.ENV === 'staging' || (!process.env.DEBUG && process.env.CONFIG_SENTRY_RELEASE)) {
      Chat.init(this.$store.state.common);
    }

    document.addEventListener('DOMContentLoaded', () => {
      this.updateIntialized(true);
    });

    window.addEventListener('storage', (event) => {
      try {
        const { key } = event;
        if (key === 'article-user') {
          this.refreshUserData();
        } else if (key === 'article-cart') {
          this.refreshCartData();
        }
      } catch {}
    });

    Chronicle.init();

    const ChronicleInitEvent = debounce(Chronicle.init, 1000);
    window.addEventListener('focus', ChronicleInitEvent);

    Chronicle.track('app-loaded', { location: window.location.href }, true);
  },

  methods: {
    ...mapMutations('common', [
      'updateIntialized', //
    ]),
    ...mapActions('common', [
      'fetchData', //
      'loadMessaging',
      'refresh',
      'getUser',
      'getSessionData',
      'refreshUserData',
      'refreshCartData',
    ]),

    updateCurrentRoute() {
      const {
        name, //
        path,
        params,
        query,
        meta,
      } = this.$route;
      const acceptableQueries = meta.acceptableQueries || [];
      const newQuery = {};

      if (acceptableQueries.length && Object.keys(query).length) {
        acceptableQueries.forEach((value) => {
          if (value in query) {
            newQuery[value] = query[value];
          }
        });
      }

      this.$store.commit('common/updateCurrentRoute', {
        name,
        path,
        params,
        query: newQuery,
        meta,
      });
    },
  },

  computed: {
    layout() {
      return this.$route && this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : StoreLayout;
    },
  },

  watch: {
    $route: {
      handler() {
        this.updateCurrentRoute();
      },
    },
  },
};
</script>
<style lang="scss">
html {
  width: 100%;
}

.newsletter-container.container {
  max-width: none;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 350ms ease-in-out;
}
</style>
